import React, { useMemo, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
} from 'core'
import { connect } from 'react-redux'
import {
  getTotalErcotMapping,
  postTotalErcotMapping,
  deletTotalErcotMapping,
} from './totalapi'
import CommonScreen from '../admin/component/CommonScreen'
import { Input, Button } from 'antd'
import styled from 'styled-components'
import UtilityUnitSelection from '../core/component/UtilityUnitSelection'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

const TableTD = styled.td`
  text-align: end;
`
const headers = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'equipmentName',
    display: 'Equipment Name',
    isFiltered: true,
    isRequired: true,
    width: 300,
    isKey: true,
  }),
  strCol({
    ident: 'station',
    display: 'Station',
    isFiltered: true,
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const TotalErcotMapping = ({ unitNameMap, utilityNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Select Utility/Unit : </TableTD>
            <UtilityUnitSelection
              utility={insertData.utility}
              unit={insertData.unitId}
              onUnitChange={value => {
                // setUtilityUnit(value)
                setInsertData({
                  ...insertData,
                  utility: value[0],
                  unit: value[1].substr(3),
                  unitId: value[1],
                })
              }}
              casStyle={{ marginLeft: '5px' }}
            />
          </tr>
          <tr>
            <TableTD>Equipment Name :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="equipmentName"
                value={insertData.equipmentName}
                placeholder="Equipment Name"
                name="equipmentName"
                onChange={e =>
                  setInsertData({
                    ...insertData,
                    equipmentName: e.target.value,
                  })
                }
              />
            </td>
            <TableTD>Station Code :</TableTD>
            <td style={{ minWidth: '100px' }}>
              <Input
                key="station"
                value={insertData.station}
                placeholder="Station Code"
                name="station"
                onChange={e =>
                  setInsertData({ ...insertData, station: e.target.value })
                }
              />
            </td>

            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title="ERCOT Mapping"
      header={headerWithFormatter}
      saveTask={postTotalErcotMapping}
      retrieveTask={getTotalErcotMapping}
      deleteTask={deletTotalErcotMapping}
      altBy={d => d.equipmentName}
      autoRetrieve
      widthOffset={400}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(TotalErcotMapping)
